module.exports = __webpack_public_path__ + "static/media/accessloop-video-overlay-logo.0b2a9b4a.png";